/**
 * This file was auto-generated by @openapi-qraft/cli.
 * Do not make direct changes to the file.
 */

import type {
  DeepReadonly,
  InvalidateQueryFilters,
  MutationFiltersByMutationKey,
  MutationFiltersByParameters,
  MutationVariables,
  OperationError,
  OperationInfiniteData,
  PartialParameters,
  QraftServiceOperationsToken,
  QueryFiltersByParameters,
  QueryFiltersByQueryKey,
  QueryFnOptionsByParameters,
  QueryFnOptionsByQueryKey,
  RequestFnResponse,
  ServiceOperationEnsureInfiniteQueryDataOptions,
  ServiceOperationEnsureQueryDataOptions,
  ServiceOperationFetchInfiniteQueryOptions,
  ServiceOperationFetchQueryOptions,
  ServiceOperationInfiniteQueryKey,
  ServiceOperationMutationFnOptions,
  ServiceOperationMutationKey,
  ServiceOperationQueryKey,
  ServiceOperationUseMutationOptions,
  UseQueryOptionsForUseQueries,
  UseQueryOptionsForUseSuspenseQuery,
  WithOptional,
} from '@openapi-qraft/tanstack-query-react-types';
import type {
  CancelOptions,
  DefinedInitialDataInfiniteOptions,
  DefinedInitialDataOptions,
  DefinedUseInfiniteQueryResult,
  DefinedUseQueryResult,
  InfiniteQueryPageParamsOptions,
  InvalidateOptions,
  Mutation,
  MutationCache,
  MutationState,
  NoInfer,
  QueryState,
  RefetchOptions,
  ResetOptions,
  SetDataOptions,
  UndefinedInitialDataInfiniteOptions,
  UndefinedInitialDataOptions,
  Updater,
  UseInfiniteQueryResult,
  UseMutationResult,
  UseQueryResult,
  UseSuspenseInfiniteQueryOptions,
  UseSuspenseInfiniteQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult,
} from '@tanstack/react-query';

import type { paths } from '../schema';

export interface CallsService {
  /** @summary Search */
  searchCallsSearchGet: {
    /** @summary Search */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<SearchCallsSearchGetSchema, SearchCallsSearchGetParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<SearchCallsSearchGetParameters, TMeta, TSignal>,
      client?: (
        schema: SearchCallsSearchGetSchema,
        options: {
          parameters: SearchCallsSearchGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<SearchCallsSearchGetData, SearchCallsSearchGetError>>
    ): Promise<RequestFnResponse<SearchCallsSearchGetData, SearchCallsSearchGetError>>;
    /** @summary Search */
    getQueryKey(
      parameters: DeepReadonly<SearchCallsSearchGetParameters>
    ): ServiceOperationQueryKey<SearchCallsSearchGetSchema, SearchCallsSearchGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.callsService.searchCallsSearchGet.useQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = SearchCallsSearchGetData>(
      parameters:
        | ServiceOperationQueryKey<SearchCallsSearchGetSchema, SearchCallsSearchGetParameters>
        | DeepReadonly<SearchCallsSearchGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          SearchCallsSearchGetData,
          SearchCallsSearchGetError,
          TData,
          ServiceOperationQueryKey<SearchCallsSearchGetSchema, SearchCallsSearchGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<SearchCallsSearchGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.callsService.searchCallsSearchGet.useQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = SearchCallsSearchGetData>(
      parameters:
        | ServiceOperationQueryKey<SearchCallsSearchGetSchema, SearchCallsSearchGetParameters>
        | DeepReadonly<SearchCallsSearchGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          SearchCallsSearchGetData,
          SearchCallsSearchGetError,
          TData,
          ServiceOperationQueryKey<SearchCallsSearchGetSchema, SearchCallsSearchGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<SearchCallsSearchGetError>>;
    /** @summary Search */
    getInfiniteQueryKey(
      parameters: DeepReadonly<SearchCallsSearchGetParameters>
    ): ServiceOperationInfiniteQueryKey<SearchCallsSearchGetSchema, SearchCallsSearchGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.callsService.searchCallsSearchGet.useInfiniteQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends SearchCallsSearchGetParameters,
      TQueryFnData = SearchCallsSearchGetData,
      TData = OperationInfiniteData<TQueryFnData, SearchCallsSearchGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchCallsSearchGetSchema, SearchCallsSearchGetParameters>
        | DeepReadonly<SearchCallsSearchGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          SearchCallsSearchGetError,
          TData,
          ServiceOperationInfiniteQueryKey<SearchCallsSearchGetSchema, SearchCallsSearchGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<SearchCallsSearchGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.callsService.searchCallsSearchGet.useInfiniteQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends SearchCallsSearchGetParameters,
      TQueryFnData = SearchCallsSearchGetData,
      TData = OperationInfiniteData<TQueryFnData, SearchCallsSearchGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchCallsSearchGetSchema, SearchCallsSearchGetParameters>
        | DeepReadonly<SearchCallsSearchGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          SearchCallsSearchGetError,
          TData,
          ServiceOperationInfiniteQueryKey<SearchCallsSearchGetSchema, SearchCallsSearchGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<SearchCallsSearchGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<SearchCallsSearchGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const searchCallsSearchGetTotal = qraft.callsService.searchCallsSearchGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const searchCallsSearchGetByParametersTotal = qraft.callsService.searchCallsSearchGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchCallsSearchGetSchema,
            SearchCallsSearchGetData,
            TInfinite,
            SearchCallsSearchGetParameters,
            SearchCallsSearchGetError
          >
        | QueryFiltersByQueryKey<
            SearchCallsSearchGetSchema,
            SearchCallsSearchGetData,
            TInfinite,
            SearchCallsSearchGetParameters,
            SearchCallsSearchGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const searchCallsSearchGetResults = qraft.callsService.searchCallsSearchGet.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * searchCallsSearchGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const searchCallsSearchGetCombinedResults = qraft.callsService.searchCallsSearchGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * searchCallsSearchGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          SearchCallsSearchGetSchema,
          SearchCallsSearchGetParameters,
          SearchCallsSearchGetData,
          SearchCallsSearchGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<SearchCallsSearchGetData, SearchCallsSearchGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<UseQueryResult<SearchCallsSearchGetData, SearchCallsSearchGetError>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.callsService.searchCallsSearchGet.useSuspenseQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = SearchCallsSearchGetData>(
      parameters:
        | ServiceOperationQueryKey<SearchCallsSearchGetSchema, SearchCallsSearchGetParameters>
        | DeepReadonly<SearchCallsSearchGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          SearchCallsSearchGetData,
          SearchCallsSearchGetError,
          TData,
          ServiceOperationQueryKey<SearchCallsSearchGetSchema, SearchCallsSearchGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<SearchCallsSearchGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.callsService.searchCallsSearchGet.useSuspenseInfiniteQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends SearchCallsSearchGetParameters, TData = SearchCallsSearchGetData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchCallsSearchGetSchema, SearchCallsSearchGetParameters>
        | DeepReadonly<SearchCallsSearchGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          SearchCallsSearchGetData,
          SearchCallsSearchGetError,
          OperationInfiniteData<TData, SearchCallsSearchGetParameters>,
          ServiceOperationInfiniteQueryKey<SearchCallsSearchGetSchema, SearchCallsSearchGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<SearchCallsSearchGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, SearchCallsSearchGetParameters>,
      OperationError<SearchCallsSearchGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Search
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const searchCallsSearchGetData = qraft.callsService.searchCallsSearchGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * searchCallsSearchGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const searchCallsSearchGetCombinedData = qraft.callsService.searchCallsSearchGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * searchCallsSearchGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          SearchCallsSearchGetSchema,
          SearchCallsSearchGetParameters,
          SearchCallsSearchGetData,
          SearchCallsSearchGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<SearchCallsSearchGetData, SearchCallsSearchGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<
          WithOptional<UseSuspenseQueryResult<SearchCallsSearchGetData, SearchCallsSearchGetError>, 'data'>
        >
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Search */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        SearchCallsSearchGetSchema,
        SearchCallsSearchGetData,
        SearchCallsSearchGetParameters,
        SearchCallsSearchGetError
      >
    ): Promise<SearchCallsSearchGetData>;
    /** @summary Search */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        SearchCallsSearchGetSchema,
        SearchCallsSearchGetData,
        SearchCallsSearchGetParameters,
        SearchCallsSearchGetError
      >
    ): Promise<void>;
    /** @summary Search */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        SearchCallsSearchGetSchema,
        SearchCallsSearchGetData,
        SearchCallsSearchGetParameters,
        SearchCallsSearchGetError
      >
    ): Promise<SearchCallsSearchGetData>;
    /** @summary Search */
    fetchInfiniteQuery<TPageParam extends SearchCallsSearchGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        SearchCallsSearchGetSchema,
        SearchCallsSearchGetData,
        SearchCallsSearchGetParameters,
        DeepReadonly<TPageParam>,
        SearchCallsSearchGetError
      >
    ): Promise<OperationInfiniteData<SearchCallsSearchGetData, SearchCallsSearchGetParameters>>;
    /** @summary Search */
    prefetchInfiniteQuery<TPageParam extends SearchCallsSearchGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        SearchCallsSearchGetSchema,
        SearchCallsSearchGetData,
        SearchCallsSearchGetParameters,
        DeepReadonly<TPageParam>,
        SearchCallsSearchGetError
      >
    ): Promise<void>;
    /** @summary Search */
    ensureInfiniteQueryData<TPageParam extends SearchCallsSearchGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        SearchCallsSearchGetSchema,
        SearchCallsSearchGetData,
        SearchCallsSearchGetParameters,
        DeepReadonly<TPageParam>,
        SearchCallsSearchGetError
      >
    ): Promise<OperationInfiniteData<SearchCallsSearchGetData, SearchCallsSearchGetParameters>>;
    /** @summary Search */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<SearchCallsSearchGetSchema, SearchCallsSearchGetParameters>
        | DeepReadonly<SearchCallsSearchGetParameters>
    ): SearchCallsSearchGetData | undefined;
    /** @summary Search */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<SearchCallsSearchGetSchema, SearchCallsSearchGetParameters>
        | DeepReadonly<SearchCallsSearchGetParameters>
    ): OperationInfiniteData<SearchCallsSearchGetData, SearchCallsSearchGetParameters> | undefined;
    /** @summary Search */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchCallsSearchGetSchema,
            SearchCallsSearchGetData,
            TInfinite,
            SearchCallsSearchGetParameters,
            SearchCallsSearchGetError
          >
        | QueryFiltersByQueryKey<
            SearchCallsSearchGetSchema,
            SearchCallsSearchGetData,
            TInfinite,
            SearchCallsSearchGetParameters,
            SearchCallsSearchGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<SearchCallsSearchGetSchema, SearchCallsSearchGetParameters>,
            data: NoInfer<OperationInfiniteData<SearchCallsSearchGetData, SearchCallsSearchGetParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<SearchCallsSearchGetSchema, SearchCallsSearchGetParameters>,
            data: SearchCallsSearchGetData | undefined,
          ]
        >;
    /** @summary Search */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<SearchCallsSearchGetSchema, SearchCallsSearchGetParameters>
        | DeepReadonly<SearchCallsSearchGetParameters>
    ): QueryState<SearchCallsSearchGetData, SearchCallsSearchGetError> | undefined;
    /** @summary Search */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<SearchCallsSearchGetParameters>
        | ServiceOperationInfiniteQueryKey<SearchCallsSearchGetSchema, SearchCallsSearchGetParameters>
    ):
      | QueryState<
          OperationInfiniteData<SearchCallsSearchGetData, SearchCallsSearchGetParameters>,
          SearchCallsSearchGetError
        >
      | undefined;
    /** @summary Search */
    setQueryData(
      parameters:
        | DeepReadonly<SearchCallsSearchGetParameters>
        | ServiceOperationQueryKey<SearchCallsSearchGetSchema, SearchCallsSearchGetParameters>,
      updater: Updater<
        NoInfer<SearchCallsSearchGetData> | undefined,
        NoInfer<DeepReadonly<SearchCallsSearchGetData>> | undefined
      >,
      options?: SetDataOptions
    ): SearchCallsSearchGetData | undefined;
    /** @summary Search */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<SearchCallsSearchGetParameters>
        | ServiceOperationInfiniteQueryKey<SearchCallsSearchGetSchema, SearchCallsSearchGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<SearchCallsSearchGetData, SearchCallsSearchGetParameters>> | undefined,
        | NoInfer<DeepReadonly<OperationInfiniteData<SearchCallsSearchGetData, SearchCallsSearchGetParameters>>>
        | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<SearchCallsSearchGetData, SearchCallsSearchGetParameters> | undefined;
    /** @summary Search */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            SearchCallsSearchGetSchema,
            SearchCallsSearchGetData,
            TInfinite,
            SearchCallsSearchGetParameters,
            SearchCallsSearchGetError
          >
        | QueryFiltersByQueryKey<
            SearchCallsSearchGetSchema,
            SearchCallsSearchGetData,
            TInfinite,
            SearchCallsSearchGetParameters,
            SearchCallsSearchGetError
          >,
      updater: Updater<NoInfer<SearchCallsSearchGetData> | undefined, NoInfer<SearchCallsSearchGetData> | undefined>,
      options?: SetDataOptions
    ): Array<SearchCallsSearchGetData | undefined>;
    /** @summary Search */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        SearchCallsSearchGetSchema,
        SearchCallsSearchGetData,
        TInfinite,
        SearchCallsSearchGetParameters,
        SearchCallsSearchGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Search */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchCallsSearchGetSchema,
            SearchCallsSearchGetData,
            TInfinite,
            SearchCallsSearchGetParameters,
            SearchCallsSearchGetError
          >
        | QueryFiltersByQueryKey<
            SearchCallsSearchGetSchema,
            SearchCallsSearchGetData,
            TInfinite,
            SearchCallsSearchGetParameters,
            SearchCallsSearchGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Search */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchCallsSearchGetSchema,
            SearchCallsSearchGetData,
            TInfinite,
            SearchCallsSearchGetParameters,
            SearchCallsSearchGetError
          >
        | QueryFiltersByQueryKey<
            SearchCallsSearchGetSchema,
            SearchCallsSearchGetData,
            TInfinite,
            SearchCallsSearchGetParameters,
            SearchCallsSearchGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Search */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchCallsSearchGetSchema,
            SearchCallsSearchGetData,
            TInfinite,
            SearchCallsSearchGetParameters,
            SearchCallsSearchGetError
          >
        | QueryFiltersByQueryKey<
            SearchCallsSearchGetSchema,
            SearchCallsSearchGetData,
            TInfinite,
            SearchCallsSearchGetParameters,
            SearchCallsSearchGetError
          >
    ): void;
    /** @summary Search */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchCallsSearchGetSchema,
            SearchCallsSearchGetData,
            TInfinite,
            SearchCallsSearchGetParameters,
            SearchCallsSearchGetError
          >
        | QueryFiltersByQueryKey<
            SearchCallsSearchGetSchema,
            SearchCallsSearchGetData,
            TInfinite,
            SearchCallsSearchGetParameters,
            SearchCallsSearchGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Search */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            SearchCallsSearchGetSchema,
            SearchCallsSearchGetData,
            TInfinite,
            SearchCallsSearchGetParameters,
            SearchCallsSearchGetError
          >
        | QueryFiltersByQueryKey<
            SearchCallsSearchGetSchema,
            SearchCallsSearchGetData,
            TInfinite,
            SearchCallsSearchGetParameters,
            SearchCallsSearchGetError
          >
    ): number;
    schema: SearchCallsSearchGetSchema;
    types: {
      parameters: SearchCallsSearchGetParameters;
      data: SearchCallsSearchGetData;
      error: SearchCallsSearchGetError;
    };
  };
  /** @summary Get Analytics */
  getCallAnalytics: {
    /** @summary Get Analytics */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetCallAnalyticsSchema, GetCallAnalyticsParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<GetCallAnalyticsParameters, TMeta, TSignal>,
      client?: (
        schema: GetCallAnalyticsSchema,
        options: {
          parameters: GetCallAnalyticsParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetCallAnalyticsData, GetCallAnalyticsError>>
    ): Promise<RequestFnResponse<GetCallAnalyticsData, GetCallAnalyticsError>>;
    /** @summary Get Analytics */
    getQueryKey(
      parameters: DeepReadonly<GetCallAnalyticsParameters>
    ): ServiceOperationQueryKey<GetCallAnalyticsSchema, GetCallAnalyticsParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Analytics
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.callsService.getCallAnalytics.useQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetCallAnalyticsData>(
      parameters:
        | ServiceOperationQueryKey<GetCallAnalyticsSchema, GetCallAnalyticsParameters>
        | DeepReadonly<GetCallAnalyticsParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetCallAnalyticsData,
          GetCallAnalyticsError,
          TData,
          ServiceOperationQueryKey<GetCallAnalyticsSchema, GetCallAnalyticsParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetCallAnalyticsError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get Analytics
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.callsService.getCallAnalytics.useQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useQuery<TData = GetCallAnalyticsData>(
      parameters:
        | ServiceOperationQueryKey<GetCallAnalyticsSchema, GetCallAnalyticsParameters>
        | DeepReadonly<GetCallAnalyticsParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetCallAnalyticsData,
          GetCallAnalyticsError,
          TData,
          ServiceOperationQueryKey<GetCallAnalyticsSchema, GetCallAnalyticsParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetCallAnalyticsError>>;
    /** @summary Get Analytics */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetCallAnalyticsParameters>
    ): ServiceOperationInfiniteQueryKey<GetCallAnalyticsSchema, GetCallAnalyticsParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Analytics
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.callsService.getCallAnalytics.useInfiniteQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetCallAnalyticsParameters,
      TQueryFnData = GetCallAnalyticsData,
      TData = OperationInfiniteData<TQueryFnData, GetCallAnalyticsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetCallAnalyticsSchema, GetCallAnalyticsParameters>
        | DeepReadonly<GetCallAnalyticsParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetCallAnalyticsError,
          TData,
          ServiceOperationInfiniteQueryKey<GetCallAnalyticsSchema, GetCallAnalyticsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetCallAnalyticsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get Analytics
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.callsService.getCallAnalytics.useInfiniteQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetCallAnalyticsParameters,
      TQueryFnData = GetCallAnalyticsData,
      TData = OperationInfiniteData<TQueryFnData, GetCallAnalyticsParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetCallAnalyticsSchema, GetCallAnalyticsParameters>
        | DeepReadonly<GetCallAnalyticsParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetCallAnalyticsError,
          TData,
          ServiceOperationInfiniteQueryKey<GetCallAnalyticsSchema, GetCallAnalyticsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetCallAnalyticsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetCallAnalyticsError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get Analytics
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getCallAnalyticsTotal = qraft.callsService.getCallAnalytics.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getCallAnalyticsByParametersTotal = qraft.callsService.getCallAnalytics.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         query: {
     *             office_id: officeId
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallAnalyticsSchema,
            GetCallAnalyticsData,
            TInfinite,
            GetCallAnalyticsParameters,
            GetCallAnalyticsError
          >
        | QueryFiltersByQueryKey<
            GetCallAnalyticsSchema,
            GetCallAnalyticsData,
            TInfinite,
            GetCallAnalyticsParameters,
            GetCallAnalyticsError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get Analytics
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getCallAnalyticsResults = qraft.callsService.getCallAnalytics.useQueries({
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getCallAnalyticsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getCallAnalyticsCombinedResults = qraft.callsService.getCallAnalytics.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getCallAnalyticsCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetCallAnalyticsSchema,
          GetCallAnalyticsParameters,
          GetCallAnalyticsData,
          GetCallAnalyticsError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetCallAnalyticsData, GetCallAnalyticsError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<GetCallAnalyticsData, GetCallAnalyticsError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get Analytics
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.callsService.getCallAnalytics.useSuspenseQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetCallAnalyticsData>(
      parameters:
        | ServiceOperationQueryKey<GetCallAnalyticsSchema, GetCallAnalyticsParameters>
        | DeepReadonly<GetCallAnalyticsParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetCallAnalyticsData,
          GetCallAnalyticsError,
          TData,
          ServiceOperationQueryKey<GetCallAnalyticsSchema, GetCallAnalyticsParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetCallAnalyticsError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get Analytics
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.callsService.getCallAnalytics.useSuspenseInfiniteQuery({
     *     query: {
     *         office_id: officeId
     *     }
     * }, {
     *     initialPageParam: {
     *         query: {
     *             office_id: initialOfficeId
     *         }
     *     },
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetCallAnalyticsParameters, TData = GetCallAnalyticsData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetCallAnalyticsSchema, GetCallAnalyticsParameters>
        | DeepReadonly<GetCallAnalyticsParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetCallAnalyticsData,
          GetCallAnalyticsError,
          OperationInfiniteData<TData, GetCallAnalyticsParameters>,
          ServiceOperationInfiniteQueryKey<GetCallAnalyticsSchema, GetCallAnalyticsParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetCallAnalyticsData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetCallAnalyticsParameters>,
      OperationError<GetCallAnalyticsError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get Analytics
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getCallAnalyticsData = qraft.callsService.getCallAnalytics.useSuspenseQueries({
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getCallAnalyticsResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getCallAnalyticsCombinedData = qraft.callsService.getCallAnalytics.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             query: {
     *                 office_id: officeId1
     *             }
     *         },
     *         {
     *             query: {
     *                 office_id: officeId2
     *             }
     *         }
     *     ]
     * });
     * getCallAnalyticsCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetCallAnalyticsSchema,
          GetCallAnalyticsParameters,
          GetCallAnalyticsData,
          GetCallAnalyticsError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetCallAnalyticsData, GetCallAnalyticsError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<GetCallAnalyticsData, GetCallAnalyticsError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get Analytics */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetCallAnalyticsSchema,
        GetCallAnalyticsData,
        GetCallAnalyticsParameters,
        GetCallAnalyticsError
      >
    ): Promise<GetCallAnalyticsData>;
    /** @summary Get Analytics */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetCallAnalyticsSchema,
        GetCallAnalyticsData,
        GetCallAnalyticsParameters,
        GetCallAnalyticsError
      >
    ): Promise<void>;
    /** @summary Get Analytics */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetCallAnalyticsSchema,
        GetCallAnalyticsData,
        GetCallAnalyticsParameters,
        GetCallAnalyticsError
      >
    ): Promise<GetCallAnalyticsData>;
    /** @summary Get Analytics */
    fetchInfiniteQuery<TPageParam extends GetCallAnalyticsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetCallAnalyticsSchema,
        GetCallAnalyticsData,
        GetCallAnalyticsParameters,
        DeepReadonly<TPageParam>,
        GetCallAnalyticsError
      >
    ): Promise<OperationInfiniteData<GetCallAnalyticsData, GetCallAnalyticsParameters>>;
    /** @summary Get Analytics */
    prefetchInfiniteQuery<TPageParam extends GetCallAnalyticsParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetCallAnalyticsSchema,
        GetCallAnalyticsData,
        GetCallAnalyticsParameters,
        DeepReadonly<TPageParam>,
        GetCallAnalyticsError
      >
    ): Promise<void>;
    /** @summary Get Analytics */
    ensureInfiniteQueryData<TPageParam extends GetCallAnalyticsParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetCallAnalyticsSchema,
        GetCallAnalyticsData,
        GetCallAnalyticsParameters,
        DeepReadonly<TPageParam>,
        GetCallAnalyticsError
      >
    ): Promise<OperationInfiniteData<GetCallAnalyticsData, GetCallAnalyticsParameters>>;
    /** @summary Get Analytics */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetCallAnalyticsSchema, GetCallAnalyticsParameters>
        | DeepReadonly<GetCallAnalyticsParameters>
    ): GetCallAnalyticsData | undefined;
    /** @summary Get Analytics */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetCallAnalyticsSchema, GetCallAnalyticsParameters>
        | DeepReadonly<GetCallAnalyticsParameters>
    ): OperationInfiniteData<GetCallAnalyticsData, GetCallAnalyticsParameters> | undefined;
    /** @summary Get Analytics */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallAnalyticsSchema,
            GetCallAnalyticsData,
            TInfinite,
            GetCallAnalyticsParameters,
            GetCallAnalyticsError
          >
        | QueryFiltersByQueryKey<
            GetCallAnalyticsSchema,
            GetCallAnalyticsData,
            TInfinite,
            GetCallAnalyticsParameters,
            GetCallAnalyticsError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetCallAnalyticsSchema, GetCallAnalyticsParameters>,
            data: NoInfer<OperationInfiniteData<GetCallAnalyticsData, GetCallAnalyticsParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetCallAnalyticsSchema, GetCallAnalyticsParameters>,
            data: GetCallAnalyticsData | undefined,
          ]
        >;
    /** @summary Get Analytics */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetCallAnalyticsSchema, GetCallAnalyticsParameters>
        | DeepReadonly<GetCallAnalyticsParameters>
    ): QueryState<GetCallAnalyticsData, GetCallAnalyticsError> | undefined;
    /** @summary Get Analytics */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetCallAnalyticsParameters>
        | ServiceOperationInfiniteQueryKey<GetCallAnalyticsSchema, GetCallAnalyticsParameters>
    ):
      | QueryState<OperationInfiniteData<GetCallAnalyticsData, GetCallAnalyticsParameters>, GetCallAnalyticsError>
      | undefined;
    /** @summary Get Analytics */
    setQueryData(
      parameters:
        | DeepReadonly<GetCallAnalyticsParameters>
        | ServiceOperationQueryKey<GetCallAnalyticsSchema, GetCallAnalyticsParameters>,
      updater: Updater<
        NoInfer<GetCallAnalyticsData> | undefined,
        NoInfer<DeepReadonly<GetCallAnalyticsData>> | undefined
      >,
      options?: SetDataOptions
    ): GetCallAnalyticsData | undefined;
    /** @summary Get Analytics */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetCallAnalyticsParameters>
        | ServiceOperationInfiniteQueryKey<GetCallAnalyticsSchema, GetCallAnalyticsParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetCallAnalyticsData, GetCallAnalyticsParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<GetCallAnalyticsData, GetCallAnalyticsParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetCallAnalyticsData, GetCallAnalyticsParameters> | undefined;
    /** @summary Get Analytics */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetCallAnalyticsSchema,
            GetCallAnalyticsData,
            TInfinite,
            GetCallAnalyticsParameters,
            GetCallAnalyticsError
          >
        | QueryFiltersByQueryKey<
            GetCallAnalyticsSchema,
            GetCallAnalyticsData,
            TInfinite,
            GetCallAnalyticsParameters,
            GetCallAnalyticsError
          >,
      updater: Updater<NoInfer<GetCallAnalyticsData> | undefined, NoInfer<GetCallAnalyticsData> | undefined>,
      options?: SetDataOptions
    ): Array<GetCallAnalyticsData | undefined>;
    /** @summary Get Analytics */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetCallAnalyticsSchema,
        GetCallAnalyticsData,
        TInfinite,
        GetCallAnalyticsParameters,
        GetCallAnalyticsError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get Analytics */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallAnalyticsSchema,
            GetCallAnalyticsData,
            TInfinite,
            GetCallAnalyticsParameters,
            GetCallAnalyticsError
          >
        | QueryFiltersByQueryKey<
            GetCallAnalyticsSchema,
            GetCallAnalyticsData,
            TInfinite,
            GetCallAnalyticsParameters,
            GetCallAnalyticsError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get Analytics */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallAnalyticsSchema,
            GetCallAnalyticsData,
            TInfinite,
            GetCallAnalyticsParameters,
            GetCallAnalyticsError
          >
        | QueryFiltersByQueryKey<
            GetCallAnalyticsSchema,
            GetCallAnalyticsData,
            TInfinite,
            GetCallAnalyticsParameters,
            GetCallAnalyticsError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get Analytics */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallAnalyticsSchema,
            GetCallAnalyticsData,
            TInfinite,
            GetCallAnalyticsParameters,
            GetCallAnalyticsError
          >
        | QueryFiltersByQueryKey<
            GetCallAnalyticsSchema,
            GetCallAnalyticsData,
            TInfinite,
            GetCallAnalyticsParameters,
            GetCallAnalyticsError
          >
    ): void;
    /** @summary Get Analytics */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallAnalyticsSchema,
            GetCallAnalyticsData,
            TInfinite,
            GetCallAnalyticsParameters,
            GetCallAnalyticsError
          >
        | QueryFiltersByQueryKey<
            GetCallAnalyticsSchema,
            GetCallAnalyticsData,
            TInfinite,
            GetCallAnalyticsParameters,
            GetCallAnalyticsError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get Analytics */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallAnalyticsSchema,
            GetCallAnalyticsData,
            TInfinite,
            GetCallAnalyticsParameters,
            GetCallAnalyticsError
          >
        | QueryFiltersByQueryKey<
            GetCallAnalyticsSchema,
            GetCallAnalyticsData,
            TInfinite,
            GetCallAnalyticsParameters,
            GetCallAnalyticsError
          >
    ): number;
    schema: GetCallAnalyticsSchema;
    types: {
      parameters: GetCallAnalyticsParameters;
      data: GetCallAnalyticsData;
      error: GetCallAnalyticsError;
    };
  };
  /** @summary Sync Call */
  syncCallCallsRetellSyncCallPost: {
    /** @summary Sync Call */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options: ServiceOperationMutationFnOptions<
        SyncCallCallsRetellSyncCallPostBody,
        SyncCallCallsRetellSyncCallPostParameters,
        TMeta,
        TSignal
      >,
      client?: (
        schema: SyncCallCallsRetellSyncCallPostSchema,
        options: ServiceOperationMutationFnOptions<
          SyncCallCallsRetellSyncCallPostBody,
          SyncCallCallsRetellSyncCallPostParameters,
          TMeta,
          TSignal
        >
      ) => Promise<RequestFnResponse<SyncCallCallsRetellSyncCallPostData, SyncCallCallsRetellSyncCallPostError>>
    ): Promise<RequestFnResponse<SyncCallCallsRetellSyncCallPostData, SyncCallCallsRetellSyncCallPostError>>;
    /** @summary Sync Call */
    getMutationKey(
      parameters: DeepReadonly<SyncCallCallsRetellSyncCallPostParameters> | void
    ): ServiceOperationMutationKey<SyncCallCallsRetellSyncCallPostSchema, SyncCallCallsRetellSyncCallPostParameters>;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Sync Call
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.callsService.syncCallCallsRetellSyncCallPost.useMutation({
     *     query: {
     *         call_id: callId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.callsService.syncCallCallsRetellSyncCallPost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     query: {
     *         call_id: callId
     *     }
     * });
     * ```
     */
    useMutation<TVariables extends SyncCallCallsRetellSyncCallPostBody, TContext = unknown>(
      parameters: DeepReadonly<SyncCallCallsRetellSyncCallPostParameters>,
      options?: ServiceOperationUseMutationOptions<
        SyncCallCallsRetellSyncCallPostSchema,
        SyncCallCallsRetellSyncCallPostData,
        SyncCallCallsRetellSyncCallPostParameters,
        TVariables,
        OperationError<SyncCallCallsRetellSyncCallPostError>,
        TContext
      >
    ): UseMutationResult<
      SyncCallCallsRetellSyncCallPostData,
      OperationError<SyncCallCallsRetellSyncCallPostError>,
      TVariables | void,
      TContext
    >;
    /**
     * Enables performing asynchronous data mutation operations such as POST, PUT, PATCH, or DELETE requests.
     * Handles loading state, optimistic updates, and error handling.
     *
     * @summary Sync Call
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutation|`useMutation(...)` documentation}
     * @example Mutation with predefined parameters, e.g., for updating
     * ```ts
     * const { mutate, isPending } = qraft.callsService.syncCallCallsRetellSyncCallPost.useMutation({
     *     query: {
     *         call_id: callId
     *     }
     * })
     * mutate(body);
     * ```
     * @example Mutation without predefined parameters, e.g., for creating
     * ```ts
     * const { mutate, isPending } = qraft.callsService.syncCallCallsRetellSyncCallPost.useMutation()
     * mutate({
     *     body: bodyPayload,
     *     query: {
     *         call_id: callId
     *     }
     * });
     * ```
     */
    useMutation<
      TVariables extends MutationVariables<
        SyncCallCallsRetellSyncCallPostBody,
        SyncCallCallsRetellSyncCallPostParameters
      >,
      TContext = unknown,
    >(
      parameters: void,
      options?: ServiceOperationUseMutationOptions<
        SyncCallCallsRetellSyncCallPostSchema,
        SyncCallCallsRetellSyncCallPostData,
        SyncCallCallsRetellSyncCallPostParameters,
        TVariables,
        OperationError<SyncCallCallsRetellSyncCallPostError>,
        TContext
      >
    ): UseMutationResult<
      SyncCallCallsRetellSyncCallPostData,
      OperationError<SyncCallCallsRetellSyncCallPostError>,
      TVariables,
      TContext
    >;
    /**
     * Returns the count of currently in-progress mutations.
     *
     * @summary Sync Call
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsMutating|`useIsMutating(...)` documentation}
     * @example Check how many mutations are currently in progress for the specified service method.
     * ```ts
     * const syncCallCallsRetellSyncCallPostTotal = qraft.callsService.syncCallCallsRetellSyncCallPost.useIsMutating()
     * ```
     * @example Check how many mutations are currently in progress with the specified parameters.
     * ```ts
     * const syncCallCallsRetellSyncCallPostTotal = qraft.callsService.syncCallCallsRetellSyncCallPost.useIsMutating({
     *     parameters: {
     *         query: {
     *             call_id: callId
     *         }
     *     }
     * })
     * ```
     */
    useIsMutating<TContext = unknown>(
      filters?:
        | MutationFiltersByParameters<
            SyncCallCallsRetellSyncCallPostBody,
            SyncCallCallsRetellSyncCallPostData,
            SyncCallCallsRetellSyncCallPostParameters,
            OperationError<SyncCallCallsRetellSyncCallPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SyncCallCallsRetellSyncCallPostSchema,
            SyncCallCallsRetellSyncCallPostBody,
            SyncCallCallsRetellSyncCallPostData,
            SyncCallCallsRetellSyncCallPostParameters,
            OperationError<SyncCallCallsRetellSyncCallPostError>,
            TContext
          >
    ): number;
    /**
     * Provides access to the current state of a mutation, including its status, any resulting data, and associated errors.
     *
     * @summary Sync Call
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useMutationState|`useMutationState(...)` documentation}
     * @example Get all variables of all running mutations.
     * ```ts
     * const syncCallCallsRetellSyncCallPostPendingMutationVariables = qraft.callsService.syncCallCallsRetellSyncCallPost.useMutationState({
     *     filters: {
     *         status: "pending"
     *     },
     *     select: mutation => mutation.state.variables
     * })
     * ```
     * @example Get all data for specific mutations via the `parameters`.
     * ```ts
     * const syncCallCallsRetellSyncCallPostMutationData = qraft.callsService.syncCallCallsRetellSyncCallPost.useMutationState({
     *     filters: {
     *         parameters: {
     *             query: {
     *                 call_id: callId
     *             }
     *         }
     *     },
     *     select: mutation => mutation.state.data
     * })
     * ```
     */
    useMutationState<
      TContext = unknown,
      TResult = MutationState<
        SyncCallCallsRetellSyncCallPostData,
        OperationError<SyncCallCallsRetellSyncCallPostError>,
        MutationVariables<SyncCallCallsRetellSyncCallPostBody, SyncCallCallsRetellSyncCallPostParameters>,
        TContext
      >,
    >(options?: {
      filters?:
        | MutationFiltersByParameters<
            SyncCallCallsRetellSyncCallPostBody,
            SyncCallCallsRetellSyncCallPostData,
            SyncCallCallsRetellSyncCallPostParameters,
            OperationError<SyncCallCallsRetellSyncCallPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SyncCallCallsRetellSyncCallPostSchema,
            SyncCallCallsRetellSyncCallPostBody,
            SyncCallCallsRetellSyncCallPostData,
            SyncCallCallsRetellSyncCallPostParameters,
            OperationError<SyncCallCallsRetellSyncCallPostError>,
            TContext
          >;
      select?: (
        mutation: Mutation<
          SyncCallCallsRetellSyncCallPostData,
          OperationError<SyncCallCallsRetellSyncCallPostError>,
          MutationVariables<SyncCallCallsRetellSyncCallPostBody, SyncCallCallsRetellSyncCallPostParameters>,
          TContext
        >
      ) => TResult;
    }): Array<TResult>;
    /** @summary Sync Call */
    isMutating<TContext>(
      filters?:
        | MutationFiltersByParameters<
            SyncCallCallsRetellSyncCallPostBody,
            SyncCallCallsRetellSyncCallPostData,
            SyncCallCallsRetellSyncCallPostParameters,
            OperationError<SyncCallCallsRetellSyncCallPostError>,
            TContext
          >
        | MutationFiltersByMutationKey<
            SyncCallCallsRetellSyncCallPostSchema,
            SyncCallCallsRetellSyncCallPostBody,
            SyncCallCallsRetellSyncCallPostData,
            SyncCallCallsRetellSyncCallPostParameters,
            OperationError<SyncCallCallsRetellSyncCallPostError>,
            TContext
          >
    ): number;
    /**
     * Returns a `MutationCache` object that provides access to mutation cache operations
     * for the specific endpoint.
     *
     * @summary Sync Call
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/query-client/getMutationCache|`getMutationCache(...)` documentation}
     *
     * @example Find a mutation with specific parameters
     * ```ts
     * const mutationCache = qraft.callsService.syncCallCallsRetellSyncCallPost.getMutationCache();
     * const mutation = mutationCache.find({
     *     parameters: {
     *         query: {
     *             call_id: callId
     *         }
     *     }
     * });
     * ```
     *
     * @example Find all mutations for the endpoint
     * ```ts
     * const mutationCache = qraft.callsService.syncCallCallsRetellSyncCallPost.getMutationCache();
     * const mutations = mutationCache.findAll();
     * ```
     */
    getMutationCache(): Omit<MutationCache, 'find' | 'findAll'> & {
      find<TContext = unknown>(
        filters:
          | MutationFiltersByParameters<
              SyncCallCallsRetellSyncCallPostBody,
              SyncCallCallsRetellSyncCallPostData,
              SyncCallCallsRetellSyncCallPostParameters,
              OperationError<SyncCallCallsRetellSyncCallPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SyncCallCallsRetellSyncCallPostSchema,
              SyncCallCallsRetellSyncCallPostBody,
              SyncCallCallsRetellSyncCallPostData,
              SyncCallCallsRetellSyncCallPostParameters,
              OperationError<SyncCallCallsRetellSyncCallPostError>,
              TContext
            >
      ):
        | Mutation<
            SyncCallCallsRetellSyncCallPostData,
            SyncCallCallsRetellSyncCallPostError,
            MutationVariables<SyncCallCallsRetellSyncCallPostBody, SyncCallCallsRetellSyncCallPostParameters>,
            TContext
          >
        | undefined;
      findAll<TContext = unknown>(
        filters?:
          | MutationFiltersByParameters<
              SyncCallCallsRetellSyncCallPostBody,
              SyncCallCallsRetellSyncCallPostData,
              SyncCallCallsRetellSyncCallPostParameters,
              OperationError<SyncCallCallsRetellSyncCallPostError>,
              TContext
            >
          | MutationFiltersByMutationKey<
              SyncCallCallsRetellSyncCallPostSchema,
              SyncCallCallsRetellSyncCallPostBody,
              SyncCallCallsRetellSyncCallPostData,
              SyncCallCallsRetellSyncCallPostParameters,
              OperationError<SyncCallCallsRetellSyncCallPostError>,
              TContext
            >
      ): Array<
        Mutation<
          SyncCallCallsRetellSyncCallPostData,
          SyncCallCallsRetellSyncCallPostError,
          MutationVariables<SyncCallCallsRetellSyncCallPostBody, SyncCallCallsRetellSyncCallPostParameters>,
          TContext
        >
      >;
    };
    schema: SyncCallCallsRetellSyncCallPostSchema;
    types: {
      parameters: SyncCallCallsRetellSyncCallPostParameters;
      data: SyncCallCallsRetellSyncCallPostData;
      error: SyncCallCallsRetellSyncCallPostError;
      body: SyncCallCallsRetellSyncCallPostBody;
    };
  };
  /** @summary Get */
  getCallsIdGet: {
    /** @summary Get */
    <TMeta extends Record<string, any>, TSignal extends AbortSignal = AbortSignal>(
      options:
        | QueryFnOptionsByQueryKey<GetCallsIdGetSchema, GetCallsIdGetParameters, TMeta, TSignal>
        | QueryFnOptionsByParameters<GetCallsIdGetParameters, TMeta, TSignal>,
      client?: (
        schema: GetCallsIdGetSchema,
        options: {
          parameters: GetCallsIdGetParameters;
          signal?: TSignal;
          meta?: TMeta;
        }
      ) => Promise<RequestFnResponse<GetCallsIdGetData, GetCallsIdGetError>>
    ): Promise<RequestFnResponse<GetCallsIdGetData, GetCallsIdGetError>>;
    /** @summary Get */
    getQueryKey(
      parameters: DeepReadonly<GetCallsIdGetParameters>
    ): ServiceOperationQueryKey<GetCallsIdGetSchema, GetCallsIdGetParameters>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.callsService.getCallsIdGet.useQuery({
     *     path: {
     *         id: id
     *     }
     * })
     * ```
     */
    useQuery<TData = GetCallsIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetCallsIdGetSchema, GetCallsIdGetParameters>
        | DeepReadonly<GetCallsIdGetParameters>,
      options?: Omit<
        UndefinedInitialDataOptions<
          GetCallsIdGetData,
          GetCallsIdGetError,
          TData,
          ServiceOperationQueryKey<GetCallsIdGetSchema, GetCallsIdGetParameters>
        >,
        'queryKey'
      >
    ): UseQueryResult<TData, OperationError<GetCallsIdGetError>>;
    /**
     * Performs asynchronous data fetching, manages loading states and error handling.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQuery|`useQuery(...)` documentation}
     * @example Query with parameters
     * ```ts
     * const { data, isLoading } = qraft.callsService.getCallsIdGet.useQuery({
     *     path: {
     *         id: id
     *     }
     * })
     * ```
     */
    useQuery<TData = GetCallsIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetCallsIdGetSchema, GetCallsIdGetParameters>
        | DeepReadonly<GetCallsIdGetParameters>,
      options: Omit<
        DefinedInitialDataOptions<
          GetCallsIdGetData,
          GetCallsIdGetError,
          TData,
          ServiceOperationQueryKey<GetCallsIdGetSchema, GetCallsIdGetParameters>
        >,
        'queryKey'
      >
    ): DefinedUseQueryResult<TData, OperationError<GetCallsIdGetError>>;
    /** @summary Get */
    getInfiniteQueryKey(
      parameters: DeepReadonly<GetCallsIdGetParameters>
    ): ServiceOperationInfiniteQueryKey<GetCallsIdGetSchema, GetCallsIdGetParameters>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.callsService.getCallsIdGet.useInfiniteQuery({
     *     path: {
     *         id: id
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetCallsIdGetParameters,
      TQueryFnData = GetCallsIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetCallsIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetCallsIdGetSchema, GetCallsIdGetParameters>
        | DeepReadonly<GetCallsIdGetParameters>,
      options: Omit<
        UndefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetCallsIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetCallsIdGetSchema, GetCallsIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<TQueryFnData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseInfiniteQueryResult<TData, OperationError<GetCallsIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useInfiniteQuery|`useInfiniteQuery(...)` documentation}
     *
     * @example Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.callsService.getCallsIdGet.useInfiniteQuery({
     *     path: {
     *         id: id
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useInfiniteQuery<
      TPageParam extends GetCallsIdGetParameters,
      TQueryFnData = GetCallsIdGetData,
      TData = OperationInfiniteData<TQueryFnData, GetCallsIdGetParameters>,
    >(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetCallsIdGetSchema, GetCallsIdGetParameters>
        | DeepReadonly<GetCallsIdGetParameters>,
      options: Omit<
        DefinedInitialDataInfiniteOptions<
          TQueryFnData,
          GetCallsIdGetError,
          TData,
          ServiceOperationInfiniteQueryKey<GetCallsIdGetSchema, GetCallsIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetCallsIdGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): DefinedUseInfiniteQueryResult<TData, OperationError<GetCallsIdGetError>>;
    /**
     * Monitors the number of queries currently fetching, matching the provided filters.
     * Useful for creating loading indicators or performing actions based on active requests.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useIsFetching|`useIsFetching(...)` documentation}
     * @example Checks the total number of queries fetching from the specified service method,
     * both normal and infinite. If no parameters are provided, no filtering is applied.
     * ```ts
     * const getCallsIdGetTotal = qraft.callsService.getCallsIdGet.useIsFetching()
     * ```
     * @example Checks the number of normal queries fetching with the specified parameters.
     * ```ts
     * const getCallsIdGetByParametersTotal = qraft.callsService.getCallsIdGet.useIsFetching({
     *     infinite: false,
     *     parameters: {
     *         path: {
     *             id: id
     *         }
     *     }
     * })
     * ```
     */
    useIsFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallsIdGetSchema,
            GetCallsIdGetData,
            TInfinite,
            GetCallsIdGetParameters,
            GetCallsIdGetError
          >
        | QueryFiltersByQueryKey<
            GetCallsIdGetSchema,
            GetCallsIdGetData,
            TInfinite,
            GetCallsIdGetParameters,
            GetCallsIdGetError
          >
    ): number;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently. This is especially useful for managing complex data dependencies in parallel.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useQueries|`useQueries(...)` documentation}
     * @example Multiple queries. Returns `data`, `error`, `isSuccess` and other properties.
     * ```ts
     * const getCallsIdGetResults = qraft.callsService.getCallsIdGet.useQueries({
     *     queries: [
     *         {
     *             path: {
     *                 id: id1
     *             }
     *         },
     *         {
     *             path: {
     *                 id: id2
     *             }
     *         }
     *     ]
     * });
     * getCallsIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example Combined results. Only the data will be returned.
     * ```ts
     * const getCallsIdGetCombinedResults = qraft.callsService.getCallsIdGet.useQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 id: id1
     *             }
     *         },
     *         {
     *             path: {
     *                 id: id2
     *             }
     *         }
     *     ]
     * });
     * getCallsIdGetCombinedResults.forEach(data => console.log({ data }));
     * ```
     */
    useQueries<
      T extends Array<
        UseQueryOptionsForUseQueries<
          GetCallsIdGetSchema,
          GetCallsIdGetParameters,
          GetCallsIdGetData,
          GetCallsIdGetError
        >
      >,
      TCombinedResult = Array<UseQueryResult<GetCallsIdGetData, GetCallsIdGetError>>,
    >(options: {
      queries: T;
      combine?: (results: Array<UseQueryResult<GetCallsIdGetData, GetCallsIdGetError>>) => TCombinedResult;
    }): TCombinedResult;
    /**
     * Performs asynchronous data fetching with Suspense support.
     * Similar to useQuery but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQuery|`useSuspenseQuery(...)` documentation}
     * @example Suspense Query with parameters
     * ```ts
     * const data = qraft.callsService.getCallsIdGet.useSuspenseQuery({
     *     path: {
     *         id: id
     *     }
     * })
     * ```
     */
    useSuspenseQuery<TData = GetCallsIdGetData>(
      parameters:
        | ServiceOperationQueryKey<GetCallsIdGetSchema, GetCallsIdGetParameters>
        | DeepReadonly<GetCallsIdGetParameters>,
      options?: Omit<
        UseSuspenseQueryOptions<
          GetCallsIdGetData,
          GetCallsIdGetError,
          TData,
          ServiceOperationQueryKey<GetCallsIdGetSchema, GetCallsIdGetParameters>
        >,
        'queryKey'
      >
    ): UseSuspenseQueryResult<TData, OperationError<GetCallsIdGetError>>;
    /**
     * Performs asynchronous data fetching with support for infinite scrolling scenarios.
     * Manages paginated data and provides utilities for fetching additional pages.
     * It functions similarly to `useInfiniteQuery`, but with added support for React Suspense.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseInfiniteQuery|`useSuspenseInfiniteQuery(...)` documentation}
     *
     * @example Suspense Infinite Query
     * ```ts
     * const { data, isLoading, fetchNextPage } = qraft.callsService.getCallsIdGet.useSuspenseInfiniteQuery({
     *     path: {
     *         id: id
     *     }
     * }, {
     *     initialPageParam: {},
     *     getNextPageParam: (lastPage, allPages, lastPageParam, allPageParams) => getNextPageParams(lastPage)
     * })
     *
     * console.log(data);
     * fetchNextPage(); // Fetch the next page
     * ```
     */
    useSuspenseInfiniteQuery<TPageParam extends GetCallsIdGetParameters, TData = GetCallsIdGetData>(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetCallsIdGetSchema, GetCallsIdGetParameters>
        | DeepReadonly<GetCallsIdGetParameters>,
      options: Omit<
        UseSuspenseInfiniteQueryOptions<
          GetCallsIdGetData,
          GetCallsIdGetError,
          OperationInfiniteData<TData, GetCallsIdGetParameters>,
          ServiceOperationInfiniteQueryKey<GetCallsIdGetSchema, GetCallsIdGetParameters>,
          PartialParameters<DeepReadonly<TPageParam>>
        >,
        'queryKey' | 'getPreviousPageParam' | 'getNextPageParam' | 'initialPageParam'
      > &
        InfiniteQueryPageParamsOptions<GetCallsIdGetData, PartialParameters<DeepReadonly<TPageParam>>>
    ): UseSuspenseInfiniteQueryResult<
      OperationInfiniteData<TData, GetCallsIdGetParameters>,
      OperationError<GetCallsIdGetError>
    >;
    /**
     * Allows you to execute multiple asynchronous data fetching operations concurrently with Suspense support.
     * Similar to useQueries but integrates with React Suspense for loading states.
     *
     * @summary Get
     * @see {@link https://openapi-qraft.github.io/openapi-qraft/docs/hooks/useSuspenseQueries|`useSuspenseQueries(...)` documentation}
     * @example Basic usage with Suspense
     * ```ts
     * const getCallsIdGetData = qraft.callsService.getCallsIdGet.useSuspenseQueries({
     *     queries: [
     *         {
     *             path: {
     *                 id: id1
     *             }
     *         },
     *         {
     *             path: {
     *                 id: id2
     *             }
     *         }
     *     ]
     * });
     * getCallsIdGetResults.forEach(({ isSuccess, data, error }) => console.log({ isSuccess, data, error }));
     * ```
     * @example With data transformation using combine
     * ```ts
     * const getCallsIdGetCombinedData = qraft.callsService.getCallsIdGet.useSuspenseQueries({
     *     combine: results => results.map(result => result.data),
     *     queries: [
     *         {
     *             path: {
     *                 id: id1
     *             }
     *         },
     *         {
     *             path: {
     *                 id: id2
     *             }
     *         }
     *     ]
     * });
     * getCallsIdGetCombinedData.forEach(data => console.log({ data }));
     * ```
     */
    useSuspenseQueries<
      T extends Array<
        UseQueryOptionsForUseSuspenseQuery<
          GetCallsIdGetSchema,
          GetCallsIdGetParameters,
          GetCallsIdGetData,
          GetCallsIdGetError
        >
      >,
      TCombinedResult = Array<UseSuspenseQueryResult<GetCallsIdGetData, GetCallsIdGetError>>,
    >(options: {
      queries: T;
      combine?: (
        results: Array<WithOptional<UseSuspenseQueryResult<GetCallsIdGetData, GetCallsIdGetError>, 'data'>>
      ) => TCombinedResult;
    }): TCombinedResult;
    /** @summary Get */
    fetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetCallsIdGetSchema,
        GetCallsIdGetData,
        GetCallsIdGetParameters,
        GetCallsIdGetError
      >
    ): Promise<GetCallsIdGetData>;
    /** @summary Get */
    prefetchQuery(
      options: ServiceOperationFetchQueryOptions<
        GetCallsIdGetSchema,
        GetCallsIdGetData,
        GetCallsIdGetParameters,
        GetCallsIdGetError
      >
    ): Promise<void>;
    /** @summary Get */
    ensureQueryData(
      options: ServiceOperationEnsureQueryDataOptions<
        GetCallsIdGetSchema,
        GetCallsIdGetData,
        GetCallsIdGetParameters,
        GetCallsIdGetError
      >
    ): Promise<GetCallsIdGetData>;
    /** @summary Get */
    fetchInfiniteQuery<TPageParam extends GetCallsIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetCallsIdGetSchema,
        GetCallsIdGetData,
        GetCallsIdGetParameters,
        DeepReadonly<TPageParam>,
        GetCallsIdGetError
      >
    ): Promise<OperationInfiniteData<GetCallsIdGetData, GetCallsIdGetParameters>>;
    /** @summary Get */
    prefetchInfiniteQuery<TPageParam extends GetCallsIdGetParameters>(
      options: ServiceOperationFetchInfiniteQueryOptions<
        GetCallsIdGetSchema,
        GetCallsIdGetData,
        GetCallsIdGetParameters,
        DeepReadonly<TPageParam>,
        GetCallsIdGetError
      >
    ): Promise<void>;
    /** @summary Get */
    ensureInfiniteQueryData<TPageParam extends GetCallsIdGetParameters>(
      options: ServiceOperationEnsureInfiniteQueryDataOptions<
        GetCallsIdGetSchema,
        GetCallsIdGetData,
        GetCallsIdGetParameters,
        DeepReadonly<TPageParam>,
        GetCallsIdGetError
      >
    ): Promise<OperationInfiniteData<GetCallsIdGetData, GetCallsIdGetParameters>>;
    /** @summary Get */
    getQueryData(
      parameters:
        | ServiceOperationQueryKey<GetCallsIdGetSchema, GetCallsIdGetParameters>
        | DeepReadonly<GetCallsIdGetParameters>
    ): GetCallsIdGetData | undefined;
    /** @summary Get */
    getInfiniteQueryData(
      parameters:
        | ServiceOperationInfiniteQueryKey<GetCallsIdGetSchema, GetCallsIdGetParameters>
        | DeepReadonly<GetCallsIdGetParameters>
    ): OperationInfiniteData<GetCallsIdGetData, GetCallsIdGetParameters> | undefined;
    /** @summary Get */
    getQueriesData<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallsIdGetSchema,
            GetCallsIdGetData,
            TInfinite,
            GetCallsIdGetParameters,
            GetCallsIdGetError
          >
        | QueryFiltersByQueryKey<
            GetCallsIdGetSchema,
            GetCallsIdGetData,
            TInfinite,
            GetCallsIdGetParameters,
            GetCallsIdGetError
          >
    ): TInfinite extends true
      ? Array<
          [
            queryKey: ServiceOperationInfiniteQueryKey<GetCallsIdGetSchema, GetCallsIdGetParameters>,
            data: NoInfer<OperationInfiniteData<GetCallsIdGetData, GetCallsIdGetParameters>> | undefined,
          ]
        >
      : Array<
          [
            queryKey: ServiceOperationQueryKey<GetCallsIdGetSchema, GetCallsIdGetParameters>,
            data: GetCallsIdGetData | undefined,
          ]
        >;
    /** @summary Get */
    getQueryState(
      parameters:
        | ServiceOperationQueryKey<GetCallsIdGetSchema, GetCallsIdGetParameters>
        | DeepReadonly<GetCallsIdGetParameters>
    ): QueryState<GetCallsIdGetData, GetCallsIdGetError> | undefined;
    /** @summary Get */
    getInfiniteQueryState(
      parameters:
        | DeepReadonly<GetCallsIdGetParameters>
        | ServiceOperationInfiniteQueryKey<GetCallsIdGetSchema, GetCallsIdGetParameters>
    ): QueryState<OperationInfiniteData<GetCallsIdGetData, GetCallsIdGetParameters>, GetCallsIdGetError> | undefined;
    /** @summary Get */
    setQueryData(
      parameters:
        | DeepReadonly<GetCallsIdGetParameters>
        | ServiceOperationQueryKey<GetCallsIdGetSchema, GetCallsIdGetParameters>,
      updater: Updater<NoInfer<GetCallsIdGetData> | undefined, NoInfer<DeepReadonly<GetCallsIdGetData>> | undefined>,
      options?: SetDataOptions
    ): GetCallsIdGetData | undefined;
    /** @summary Get */
    setInfiniteQueryData(
      parameters:
        | DeepReadonly<GetCallsIdGetParameters>
        | ServiceOperationInfiniteQueryKey<GetCallsIdGetSchema, GetCallsIdGetParameters>,
      updater: Updater<
        NoInfer<OperationInfiniteData<GetCallsIdGetData, GetCallsIdGetParameters>> | undefined,
        NoInfer<DeepReadonly<OperationInfiniteData<GetCallsIdGetData, GetCallsIdGetParameters>>> | undefined
      >,
      options?: SetDataOptions
    ): OperationInfiniteData<GetCallsIdGetData, GetCallsIdGetParameters> | undefined;
    /** @summary Get */
    setQueriesData<TInfinite extends boolean = false>(
      filters:
        | QueryFiltersByParameters<
            GetCallsIdGetSchema,
            GetCallsIdGetData,
            TInfinite,
            GetCallsIdGetParameters,
            GetCallsIdGetError
          >
        | QueryFiltersByQueryKey<
            GetCallsIdGetSchema,
            GetCallsIdGetData,
            TInfinite,
            GetCallsIdGetParameters,
            GetCallsIdGetError
          >,
      updater: Updater<NoInfer<GetCallsIdGetData> | undefined, NoInfer<GetCallsIdGetData> | undefined>,
      options?: SetDataOptions
    ): Array<GetCallsIdGetData | undefined>;
    /** @summary Get */
    invalidateQueries<TInfinite extends boolean = false>(
      filters?: InvalidateQueryFilters<
        GetCallsIdGetSchema,
        GetCallsIdGetData,
        TInfinite,
        GetCallsIdGetParameters,
        GetCallsIdGetError
      >,
      options?: InvalidateOptions
    ): Promise<void>;
    /** @summary Get */
    refetchQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallsIdGetSchema,
            GetCallsIdGetData,
            TInfinite,
            GetCallsIdGetParameters,
            GetCallsIdGetError
          >
        | QueryFiltersByQueryKey<
            GetCallsIdGetSchema,
            GetCallsIdGetData,
            TInfinite,
            GetCallsIdGetParameters,
            GetCallsIdGetError
          >,
      options?: RefetchOptions
    ): Promise<void>;
    /** @summary Get */
    cancelQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallsIdGetSchema,
            GetCallsIdGetData,
            TInfinite,
            GetCallsIdGetParameters,
            GetCallsIdGetError
          >
        | QueryFiltersByQueryKey<
            GetCallsIdGetSchema,
            GetCallsIdGetData,
            TInfinite,
            GetCallsIdGetParameters,
            GetCallsIdGetError
          >,
      options?: CancelOptions
    ): Promise<void>;
    /** @summary Get */
    removeQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallsIdGetSchema,
            GetCallsIdGetData,
            TInfinite,
            GetCallsIdGetParameters,
            GetCallsIdGetError
          >
        | QueryFiltersByQueryKey<
            GetCallsIdGetSchema,
            GetCallsIdGetData,
            TInfinite,
            GetCallsIdGetParameters,
            GetCallsIdGetError
          >
    ): void;
    /** @summary Get */
    resetQueries<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallsIdGetSchema,
            GetCallsIdGetData,
            TInfinite,
            GetCallsIdGetParameters,
            GetCallsIdGetError
          >
        | QueryFiltersByQueryKey<
            GetCallsIdGetSchema,
            GetCallsIdGetData,
            TInfinite,
            GetCallsIdGetParameters,
            GetCallsIdGetError
          >,
      options?: ResetOptions
    ): Promise<void>;
    /** @summary Get */
    isFetching<TInfinite extends boolean = false>(
      filters?:
        | QueryFiltersByParameters<
            GetCallsIdGetSchema,
            GetCallsIdGetData,
            TInfinite,
            GetCallsIdGetParameters,
            GetCallsIdGetError
          >
        | QueryFiltersByQueryKey<
            GetCallsIdGetSchema,
            GetCallsIdGetData,
            TInfinite,
            GetCallsIdGetParameters,
            GetCallsIdGetError
          >
    ): number;
    schema: GetCallsIdGetSchema;
    types: {
      parameters: GetCallsIdGetParameters;
      data: GetCallsIdGetData;
      error: GetCallsIdGetError;
    };
  };
}
/** @summary Search */
export const searchCallsSearchGet = {
  schema: {
    method: 'get',
    url: '/calls/search',
    security: ['HTTPBearer'],
  },
} as {
  schema: SearchCallsSearchGetSchema;
  [QraftServiceOperationsToken]: CallsService['searchCallsSearchGet'];
};
/** @summary Get Analytics */
export const getCallAnalytics = {
  schema: {
    method: 'get',
    url: '/calls/analytics',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetCallAnalyticsSchema;
  [QraftServiceOperationsToken]: CallsService['getCallAnalytics'];
};
/** @summary Sync Call */
export const syncCallCallsRetellSyncCallPost = {
  schema: {
    method: 'post',
    url: '/calls/retell/sync_call',
    security: ['HTTPBearer'],
  },
} as {
  schema: SyncCallCallsRetellSyncCallPostSchema;
  [QraftServiceOperationsToken]: CallsService['syncCallCallsRetellSyncCallPost'];
};
/** @summary Get */
export const getCallsIdGet = {
  schema: {
    method: 'get',
    url: '/calls/{id}',
    security: ['HTTPBearer'],
  },
} as {
  schema: GetCallsIdGetSchema;
  [QraftServiceOperationsToken]: CallsService['getCallsIdGet'];
};
export const callsService = {
  searchCallsSearchGet,
  getCallAnalytics,
  syncCallCallsRetellSyncCallPost,
  getCallsIdGet,
} as const;
type SearchCallsSearchGetSchema = {
  method: 'get';
  url: '/calls/search';
  security: ['HTTPBearer'];
};
type SearchCallsSearchGetParameters = paths['/calls/search']['get']['parameters'];
type SearchCallsSearchGetData = paths['/calls/search']['get']['responses']['200']['content']['application/json'];
type SearchCallsSearchGetError = paths['/calls/search']['get']['responses']['422']['content']['application/json'];
type GetCallAnalyticsSchema = {
  method: 'get';
  url: '/calls/analytics';
  security: ['HTTPBearer'];
};
type GetCallAnalyticsParameters = paths['/calls/analytics']['get']['parameters'];
type GetCallAnalyticsData = paths['/calls/analytics']['get']['responses']['200']['content']['application/json'];
type GetCallAnalyticsError = paths['/calls/analytics']['get']['responses']['422']['content']['application/json'];
type SyncCallCallsRetellSyncCallPostSchema = {
  method: 'post';
  url: '/calls/retell/sync_call';
  security: ['HTTPBearer'];
};
type SyncCallCallsRetellSyncCallPostParameters = paths['/calls/retell/sync_call']['post']['parameters'];
type SyncCallCallsRetellSyncCallPostData =
  paths['/calls/retell/sync_call']['post']['responses']['200']['content']['application/json'];
type SyncCallCallsRetellSyncCallPostError =
  paths['/calls/retell/sync_call']['post']['responses']['422']['content']['application/json'];
type SyncCallCallsRetellSyncCallPostBody = undefined;
type GetCallsIdGetSchema = {
  method: 'get';
  url: '/calls/{id}';
  security: ['HTTPBearer'];
};
type GetCallsIdGetParameters = paths['/calls/{id}']['get']['parameters'];
type GetCallsIdGetData = paths['/calls/{id}']['get']['responses']['200']['content']['application/json'];
type GetCallsIdGetError = paths['/calls/{id}']['get']['responses']['422']['content']['application/json'];
